import useSiteState from '@app/state/SiteState';
import React, { useEffect } from 'react';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import UserMenuItemFragment from '@app/site/secured/_common/layout/fragment/UserMenuItemFragment';
import { Bars3Icon } from '@heroicons/react/16/solid';
import { XMarkIcon } from '@heroicons/react/20/solid';
import Avatar from '@app/component/avatar/Avatar';
import FooterFragment from '@app/site/secured/_common/layout/fragment/FooterFragment';
import DomainSelectorFragment from '@app/site/secured/_common/layout/fragment/DomainSelectorFragment';
import PageLoaderOverlay from '@app/site/PageLoaderOverlay';
import { Outlet, useNavigate } from 'react-router-dom';
import CompanyHotelsProvider from '@app/site/secured/rateshopper/rates/provider/CompanyHotelsProvider';
import { useIntercom } from 'react-use-intercom';
import ProfileService from '@app/model/profile/service/ProfileService';


const GeneralSettingsLayout = React.memo(() => {
	const navigate = useNavigate();
	const principal = useSiteState(state => state.principal);
	const { update } = useIntercom();

	useEffect(() => {
		if (principal) {
			ProfileService.findIntercomHash()
				.then(hash => {
					if (!!hash) {
						update({
							email: principal.username,
							userHash: hash,
						});
					}
				});
		}
	}, [principal, update]);

	return <div className="min-h-full bg-gray-100">
		<Disclosure as="nav" className="border-b border-gray-200 bg-white">
			{({ open }) => (
				<>
					<div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
						<div className="flex h-16 justify-between">
							<div className="flex flex-shrink-0 items-center">
								<DomainSelectorFragment />
								<div className="cursor-pointer" onClick={() => {
									navigate('/secured/dashboard', { replace: true });
								}}>
									<img
										className="block h-8 w-auto lg:hidden"
										src="/assets/img/brand/rp-icon.svg"
										alt="RoomPulse"
									/>
									<img
										className="hidden h-6 w-auto lg:block"
										src="/assets/img/brand/rp-logo.svg"
										alt="RoomPulse"
									/>
								</div>
							</div>


							<div className="hidden sm:ml-6 sm:flex sm:items-center">
								<div className="ml-4 flex items-center md:ml-6">
									<UserMenuItemFragment />
								</div>
							</div>
							<div className="-mr-2 flex items-center sm:hidden">
								{/* Mobile menu button */}
								<DisclosureButton
									className="relative inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
									<span className="sr-only">Open main menu</span>
									{open ? (
										<XMarkIcon className="block h-6 w-6" aria-hidden="true" />
									) : (
										<Bars3Icon className="block h-6 w-6" aria-hidden="true" />
									)}
								</DisclosureButton>
							</div>
						</div>
					</div>
					<DisclosurePanel className="sm:hidden">

						<div className="space-y-1 px-2 pt-2 pb-3 sm:px-3">
							{/*<NavigationMenuItemFragment isMobile/>*/}
						</div>
						<div className="border-t border-gray-200 pt-4 pb-3">
							<div className="flex items-center px-5">
								<div className="flex-shrink-0">
									<Avatar principal={principal!} isSmall />
								</div>
								<div className="ml-3">
									<div className="text-base font-medium text-gray-800">{principal!.name}</div>
									<div className="text-sm font-medium text-gray-500">{principal!.username}</div>
								</div>

							</div>
							<div className="mt-3 space-y-1 px-2">
								<UserMenuItemFragment isMobile />
							</div>
						</div>
					</DisclosurePanel>
				</>
			)}
		</Disclosure>
		<Outlet />
		<FooterFragment />
	</div>;
});

export default GeneralSettingsLayout;